<template>
  <fragment>
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid">
          <slot name="header"></slot>
        </div>
        <div class="container-fluid mycontainer-fluid content content_table">
          <br /><br />
          <div id="b24form"></div>
          <iframe
            src="/support.html"
            scrolling="no"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
            style="width: 100%; height: 1568px; border: 0px; overflow: hidden; padding: 0px; margin: 0px;"
          ></iframe>
        </div>
      </div>
      <!-- wraper -->
    </div>
    <slot name="footer"></slot>
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_IS_VIEW_ALL_EXPERTISE, SET_MAIN_MENU } from "@/store/actions.type";
import { ProjectsService } from "@/common/api.service";

export default {
  name: "Support",
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.$store.dispatch(SET_MAIN_MENU, []);
    if (this.currentUser.TYPE_USER === "manager") {
      ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
        let navMainMenu = [];
        if (data.START_PAGE === "REESTR_PROJECTS") {
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
        } else {
          if (data.IS_REESTR_EXPERTISE) {
            navMainMenu.push({
              name: "Реестр экспертиз",
              route: "Expertise"
            });
          }
          if (data.IS_REESTR_PROJECTS) {
            navMainMenu.push({
              name: "Реестр проектов",
              route: "Projects"
            });
          }
          /*if (data.IS_VIEW_PLAN_ES) {
            navMainMenu.push({
              name: "Заседания",
              route: "Experts"
            });
          }
          if (data.IS_VIEW_MONITOR_LIZING) {
            navMainMenu.push({
              name: "Мониторинг Лизинговых<br/> компаний",
              class: "two_line",
              route: "MonitoringLizingOrgs"
            });
          }
          if (data.IS_VIEW_GROUP_ORG) {
            navMainMenu.push({
              name: "Группы компаний",
              route: "GroupOrgs"
            });
          }*/
        }
        this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
        this.$store.dispatch(
          SET_IS_VIEW_ALL_EXPERTISE,
          data.IS_VIEW_ALL_EXPERTISE
        );
      });
    } else {
      this.$store.dispatch(SET_MAIN_MENU, [
        {
          name: "Мои проекты",
          route: "Projects"
        }
      ]);
    }
  }
};
</script>
